import controller from './promocode-has-package.controller';

export default {
  controller,
  template: require('./promocode-has-package.html')
};


// WEBPACK FOOTER //
// src/app/components/promocode-has-package/promocode-has-package.component.ts